/* eslint-disable import/prefer-default-export */
import ActionTypes from '../../constants/ActionTypes';

/* Actions */

export const toggleMenu = () => ({
  type: ActionTypes.TOGGLE_MENU,
  payload: {},
});

export const toggleMenuDesktop = () => ({
  type: ActionTypes.TOGGLE_MENU_DESKTOP,
  payload: {},
});

export const closeMenu = () => ({
  type: ActionTypes.CLOSE_MENU,
  payload: {},
});

export const toggleMode = () => ({
  type: ActionTypes.TOGGLE_MODE,
  payload: {},
});
